export default {"src":"/_next/static/media/CenterPivotFarming.26402d1e.svg","height":80,"width":80};